<template>
    <div>
        <div v-if="viewName == 'list'">
            <record15List
                :companyObj="companyObj"
                type="1"
                @clickView="clickViewBtn"
                @clickEdit="clickEditBtn"
                @clickProduct="clickProductBtn"
            />
        </div>

        <div v-if="viewName == 'edit' || viewName == 'add'">
            <addOrEditRecord15
                :hallObj="hallObj"
                :editObj="editObj"
                :readonlyTag="readonlyTag"
                @addComplete="addCallback"
                @editComplete="returnFunc"
            />
        </div>

        <div v-if="viewName == 'product'">
            <JoinHallMaterialEditor
                @clickReturnBtn="changeViewName('list')"
            />
        </div>
    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount} from "vue";
import Record15List from "@/components/shopopee/hall/record15List.vue";
import JoinHallMaterialEditor from "@/components/shopopee/hall/joinHallMaterialEditor.vue";
import AddOrEditRecord15 from "@/components/shopopee/hall/addOrEditRecord15.vue";

const props = defineProps(["companyObj"])
const emits = defineEmits(["changeView"])

const viewName = ref("list")

const editObj = ref(null)
const hallObj = ref(null)
const readonlyTag = ref(null)

const companyObj = ref(null)

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return null } })

function addCallback(){
    hallObj.value = null
    changeViewName("list")
}

function returnFunc(){
    editObj.value = null
    hallObj.value = null
    readonlyTag.value = false

    changeViewName("list")
}

function changeViewName(name){
    viewName.value = name

    if (name === "product"){
        emits("changeView", "product")
    }else{
        emits("changeView", "list")
    }

}

function clickViewBtn(obj){
    obj.additionalrecord14.country = obj.country
    readonlyTag.value = true
    hallObj.value = obj.additionalrecord14
    editObj.value = obj

    changeViewName("add")
}

function clickEditBtn(obj){
    obj.additionalrecord14.country = obj.country
    hallObj.value = obj.additionalrecord14
    editObj.value = obj

    changeViewName("edit")
}

function clickProductBtn(){
    changeViewName("product")
}

onBeforeMount(() => {
    if (null != props.companyObj){
        companyObj.value = props.companyObj
    }else{
        companyObj.value = getShopCompanyObj()
    }

})

</script>

<style scoped>

</style>